export default __webpack_public_path__ + "static/media/leitor_cartaobhbus.c2a6473f.png";